<div class="contact-container" id="contact">
	<h1>CONTACT</h1>
	<a href="mailto:andy@andysaia.com" target="_blank">andy@andysaia.com</a>
	<div class="icon-container">
		<a class="icon" href="https://twitter.com/saiacide" target="_blank">
			<img src="icons/twitter.svg" alt="twitter" />
		</a>
		<a
			class="icon"
			href="http://www.linkedin.com/pub/andy-saia/21/2b0/b60"
			target="_blank"
		>
			<img src="icons/linkedin1.svg" alt="linkedin" />
		</a>
		<a class="icon" href="https://github.com/asaia" target="_blank">
			<img src="icons/github10.svg" alt="github" />
		</a>
	</div>
	<div class="resume">
		<a href="./saia_resume.pdf" target="_blank">resume</a>
	</div>
</div>

<style>
	.contact-container {
		min-height: 1000px;
		scroll-margin-top: 100px;
		padding-top: 200px;
		padding-bottom: 500px;
		min-height: 600px;
		display: flex;
		flex-direction: column;
		text-align: center;
		justify-content: space-between;
	}

	.icon-container {
		display: flex;
		justify-content: center;
	}

	.icon img {
		transition: opacity 0.2s;
		padding: 15px;
		width: 40px;
		opacity: 1;
	}

	.icon img:hover {
		opacity: 0.3;
	}

	.resume {
		margin-top: 75px;
		margin-bottom: 75px;
	}

	.resume a {
		font-size: 16px;
		border-style: solid;
		border-color: #2d2d2d;
		border-width: 2px;
		padding: 8px 15px;
	}
</style>
